export default __webpack_public_path__ + "assets/file-icon.1a216370.svg";